import React, { useState , useEffect } from "react";
import "./RegionalTab.scss";
import StateTabContent from "./StateTabContent/StateTabContent";

import Stateicon from  "../../../../../../../Assets/AppComponent/Customersupport_icon/Stateicon.svg"
import Regionaliocn from  "../../../../../../../Assets/AppComponent/Customersupport_icon/Regionaldark.svg"
import ZoneIcons from  "../../../../../../../Assets/AppComponent/Customersupport_icon/Zoneselectedicon.svg"
import ClientIcons from  "../../../../../../../Assets/AppComponent/Customersupport_icon/ClientDark.svg"

/// selected 

import Stateicon_selected from  "../../../../../../../Assets/AppComponent/Customersupport_icon/StateSelectedicon.svg"
import Regionaliocn_selected from  "../../../../../../../Assets/AppComponent/Customersupport_icon/RegionalSelectedicon.svg"
import ZoneIcons_selected from  "../../../../../../../Assets/AppComponent/Customersupport_icon/Zoneselecticon.svg"
import ClientIcons_selected from  "../../../../../../../Assets/AppComponent/Customersupport_icon/ClientSelecticon.svg"
import SummaryCards from "./SummaryCards";
import { RegionalTabsdetails } from "./RegionalTab/RegionalTabsdetails";
import Zonecontaintab from "./ZoneTab/Zonecontaintab";
import Clientcontaintabs from "./ClientTab/Clientcontaintabs";
import { clearInternalCustomPerformanceMatrix } from "../../../../../../../Redux/Slice";
import { useDispatch, useSelector } from "react-redux";



const tabOptions = [
  {
    name: "State",
    icon: Stateicon,
    selectedIcon: Stateicon_selected,
  },
  {
    name: "Region",
    icon: Regionaliocn,
    selectedIcon: Regionaliocn_selected,
  },
  {
    name: "Zone",
    icon: ZoneIcons,
    selectedIcon: ZoneIcons_selected,
  },
  {
    name: "Client",
    icon: ClientIcons,
    selectedIcon: ClientIcons_selected,
  },
];
export default function RegionalTab({
    datas,
  PriorityValues,
  SttausValues,
  Client , range,
  date,
  Client_id
}) {
  const [activeTab, setActiveTab] = useState("State");

  const state = useSelector((state)=>state);
  const responseData = useSelector((state)=>state.InternalCustomPerformanceMatrix.internalCustomPerformanceMatrixData)
  const dispatch = useDispatch()


let isValidRange =
  Array.isArray(range) &&
  range.length > 0 &&
  range.every((date) => !!date && date !== "NaN-aN-aN");

    useEffect(()=>{
   if(state.ClientBranchIDs.SUBROLE == 3){

  const payload ={
    state:datas?.state,
    region:datas?.region,
    zone:datas?.zone,
     priority:PriorityValues,
     department:Client,
            from_date: range[0],
      to_date: range[1],
      range: isValidRange,
              date:date,
              status:SttausValues,
              client:Client_id
  }
    dispatch(clearInternalCustomPerformanceMatrix(payload))
}
  },[ datas ,PriorityValues , Client ,date ,range ,SttausValues ,Client_id ])
function truncateText(text, maxLength = 20) {
  if (typeof text !== "string") return text;
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
}



const cards = [
  {
    title: truncateText(responseData?.top_state?.state_id__state_name || "--"),
    label: "Top State",
    count: responseData?.top_state?.ticket_count != null
      ? `${responseData.top_state.ticket_count} Tickets`
      : "0",
    icon: Stateicon_selected,
  },
  {
    title: truncateText(responseData?.top_region?.region_id__region_name || "--"),
    label: "Top Region",
    count: responseData?.top_region?.ticket_count != null
      ? `${responseData.top_region.ticket_count} Tickets`
      : "0",
    icon: Regionaliocn_selected,
  },
  {
    title: truncateText(responseData?.top_zone?.zone_id__zone_name || "--"),
    label: "Top Zone",
    count: responseData?.top_zone?.ticket_count != null
      ? `${responseData.top_zone.ticket_count} Tickets`
      : "0",
    icon: ZoneIcons_selected,
  },
  {
    title: truncateText(responseData?.top_client?.client_id__client_name || "--"),
    label: "Top Client",
    count: responseData?.top_client?.ticket_count != null
      ? `${responseData.top_client.ticket_count} Tickets`
      : "0",
    icon: ClientIcons_selected,
  },
];

  return (
    <div className="regional-tab-container">
      <SummaryCards cards={cards} />


      {/* Tab Switcher */}
      <div className="tab-switcher">
{tabOptions.map((tab) => (
  <button
    key={tab.name}
    className={activeTab === tab.name ? "active" : ""}
    onClick={() => setActiveTab(tab.name)}
    style={{ display: "flex", alignItems: "center", gap: "8px" }}
  >
    <img
      src={activeTab === tab.name ? tab.selectedIcon : tab.icon}
      alt={`${tab.name} icon`}
      style={{ width: 20, height: 20 }}
    />
    {tab.name}
  </button>
))}
      </div>

<div className="chart-list-row">
       <div className="tab-contents">
    <div className="tab-content">
  {activeTab === "State" && (
    <StateTabContent
      datas={datas}
      PriorityValues={PriorityValues}
      SttausValues={SttausValues}
      Client={Client}
      range={range}
      date={date}
                    Client_id={Client_id}

    />
  )}

  {activeTab === "Region" && (
    <RegionalTabsdetails
      datas={datas}
      PriorityValues={PriorityValues}
      SttausValues={SttausValues}
      Client={Client}
            range={range}

                  date={date}

                                Client_id={Client_id}

    />
  )}

  {activeTab === "Zone" && (
    <Zonecontaintab
      datas={datas}
      PriorityValues={PriorityValues}
      SttausValues={SttausValues}
      Client={Client}
            range={range}
                  date={date}
              Client_id={Client_id}


    />
  )}

  {activeTab === "Client" && (
    <Clientcontaintabs
      datas={datas}
      PriorityValues={PriorityValues}
      SttausValues={SttausValues}
      Client={Client}
            range={range}
      date={date}
              Client_id={Client_id}

    />
  )}
</div>

      </div>
      </div>

    </div>
  );
}
